import React, { useCallback, useRef } from 'react'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { View } from 'react-native'
import {
  ListWithInfiniteScroll, Spinner, FilterMenu
} from '../../../../components'
import Filters from '../InvoicesFilters'
import PaymentCard from '../PaymentCard'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import * as paymentActions from '../../../../redux/payments/paymentActions'
import { paymentsSelector } from '../../../../redux/payments/paymentSelector'
import { setPayload } from '../../helpers'
ReactGA.pageview('/main/payments/payment')

const Payments = () => {
  const { payments, loadPage, filters, payoutTermsTypes } = useSelector(paymentsSelector)
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const modalRef = useRef(null)
  const { isTablet } = usePlatforms()

  useFocusEffect(
    useCallback(() => {
      return () => { dispatch(paymentActions.setFilters()) }
    }, [dispatch])
  )

  const onFailureCallback = useCallback(() => navigation.navigate('payments-connect'), [navigation])

  const getPayments = useCallback(() => {
    const body = setPayload(filters)
    dispatch(paymentActions.getPayments({ body }, onFailureCallback))
  }, [dispatch, filters, onFailureCallback])

  useFocusEffect(getPayments)

  const clearFilters = useCallback(() => {
    dispatch(paymentActions.setFilters())
  }, [dispatch])

  const handleSearch = useCallback((payload) => {
    dispatch(paymentActions.setFilters({
      ...payload
    }))
  }, [dispatch])

  const onOpen = () => {
    const { current = null } = modalRef
    current && current.open()
  }

  const onClose = () => {
    const { current = null } = modalRef
    current && current.close()
  }

  return (
    <View style={{ flex: 1, paddingTop: 20, paddingHorizontal: 10 }}>
      {!isTablet && (
        <FilterMenu
          openFilters={onOpen}
          handleClearFilters={clearFilters}
          applyFilters={setPayload(filters)}
        />
      )}
      <Filters
        initialValues={filters}
        onClose={onClose}
        handleSearch={handleSearch}
        handleClearFilters={clearFilters}
        modalRef={modalRef}
      />
      {loadPage ? (
        <Spinner />
      ) : (
        <ListWithInfiniteScroll
          data={payments || []}
          component={PaymentCard}
          noMore
          handleLoadMore={() => {}}
          loading={false}
          cardProps={{
            payoutTermsTypes
          }}
          noDataMessage='No payments found'
        />)}
    </View>

  )
}

export default Payments
